export default class Captcha {

    constructor() {
        const captcha   = jQuery('.elementor-field-type-sea_captcha'),
            refresh     = jQuery(captcha).find('.sfo-captcha__refresh'),
            image       = jQuery(captcha).find('.sfo-captcha__image'),
            form        = jQuery(captcha).closest('form'),
            hidden      = jQuery(captcha).find('input[name="sfo-captcha-crypt"]');

        this.$captcha   = jQuery(captcha);
        this.$refresh   = jQuery(refresh);
        this.$image     = jQuery(image);
        this.$form      = jQuery(form);
        this.$hidden    = jQuery(hidden);

        this.url_captcha = ( sfo_variables && sfo_variables.sfo_url ) ? sfo_variables.sfo_url + '/captcha-image.php' : false;

        this.init();
    }

    init() {
        this.$refresh.on('click', this.refreshHandle.bind(this) );
        
        this.$form.on('error', this.errorHandle.bind(this) ); // on fail
        this.$form.on('reset', this.resetHandle.bind(this) ); // on success

        if( this.$captcha.length > 1 ) {
            console.log('== Sea Form Captcha only optimized for one field per page. ==');
        }
    }
    
    errorHandle(e) {
        this.reset();  
    }
    resetHandle(e) {
        this.reset();
    }

    refreshHandle(e) {
        this.refresh();
    }
    
    reset() {
        this.refresh();
        this.$form.find('.elementor-field-type-sea_captcha .elementor-field-textual').val('');
    }

    refresh() {

        let _this = this;

        jQuery.ajax({
            url : sfo_variables.ajaxurl,
            type : 'post',
            data : {
                action : 'captcha',
                nonce : sfo_variables.nonce
            },
                success : function( response ) {

                    const captcha = JSON.parse(response);

                    _this.$image.attr('src', _this.url_captcha + '?crypt=' + captcha.crypturl);
                    _this.$hidden.val( captcha.cryptMd5 );
            }
        });

        return false;
    }
}